import { render, staticRenderFns } from "./BkzxDetail.vue?vue&type=template&id=20e5e0a8&scoped=true"
import script from "./BkzxDetail.vue?vue&type=script&lang=js"
export * from "./BkzxDetail.vue?vue&type=script&lang=js"
import style0 from "./BkzxDetail.vue?vue&type=style&index=0&id=20e5e0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5e0a8",
  null
  
)

export default component.exports